/** Chat messages and attachments older than this are deleted server-side and hidden on clients. */
export const CHAT_CONTENT_RETENTION_DAYS = 14;

export const CHAT_CONTENT_RETENTION_MS = CHAT_CONTENT_RETENTION_DAYS * 24 * 60 * 60 * 1000;

export function chatRetentionCutoffMs(nowMs = Date.now()): number {
  return nowMs - CHAT_CONTENT_RETENTION_MS;
}

/** Keep pending writes (no timestamp yet) and anything still inside the window. */
export function isChatContentWithinRetention(createdAtMs: number, nowMs = Date.now()): boolean {
  if (!Number.isFinite(createdAtMs) || createdAtMs <= 0) return true;
  return createdAtMs >= chatRetentionCutoffMs(nowMs);
}
